import { render, staticRenderFns } from "./foot-bar.vue?vue&type=template&id=6c95fdae&scoped=true&"
import script from "./foot-bar.vue?vue&type=script&lang=js&"
export * from "./foot-bar.vue?vue&type=script&lang=js&"
import style0 from "./foot-bar.vue?vue&type=style&index=0&id=6c95fdae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c95fdae",
  null
  
)

export default component.exports